import * as React from 'react';

function SvgSymmetryHorizontal(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M13.5 7a.5.5 0 00.24-.939l-11-6A.5.5 0 002 .5v6a.5.5 0 00.5.5h11zm.485 2.376a.5.5 0 01-.246.563l-11 6A.5.5 0 012 15.5v-6a.5.5 0 01.5-.5h11a.5.5 0 01.485.376zM11.539 10H3v4.658L11.54 10z' />
		</svg>
	);
}

export default SvgSymmetryHorizontal;
